import { Component, OnInit } from '@angular/core';

import { QuoteInfoService } from "../../services/quote-info.service";
import { CurrentUserService } from "../../services/current-user.service";
import { LoadingSpinnerService } from "../../services/loading-spinner.service";

@Component({
    selector: 'approved-lock',
    template: require('./approved-lock.component.html'),
    styles: [require('./approved-lock.component.scss')]
})

export class ApprovedLockComponent implements OnInit {

    showModal: boolean;
	approvalStatus: string;
	private messageText: string = 'This quote has been set to #REPLACESTATUS# by the facility.  Any changes made to this quote will cancel the facility decision and will require the quote to be re-submitted.';

    constructor(
        public quoteInfoService: QuoteInfoService,
        public currentUserService: CurrentUserService,
        public loadingSpinnerService: LoadingSpinnerService
    ) {}

    ngOnInit() {
        this.showModal = true;
		this.quoteInfoService.quote$.subscribe(x => {
			if (x.quoteId === null) {
				this.approvalStatus = 'Not Submitted';
				this.showModal = false;
			} else {
				this.approvalStatus = x.ApprovalStatusDescription;
			}
			
        });
    }

    get url(): string {
        return window.location.href;
    }

    closeModal() {
        this.showModal = false;
	}

	get approvalStatusTitle(): string {
		return ((this.approvalStatus === undefined || this.approvalStatus === null) ? this.messageText.replace('#REPLACESTATUS#', '') : this.messageText.replace('#REPLACESTATUS#', this.approvalStatus.toLocaleUpperCase()));
	}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/approved-lock/approved-lock.component.ts